import React from "react";
import ImportData from "../../Pages/ImportData";

const BillingData = () => {
  return (
    <div>
      <ImportData title="Billing" />
    </div>
  );
};

export default BillingData;
